import classNames from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FlawBadge from '../FlawBadge/FlawBadge';

const FlawsSection = ({ scoresheet }) => {
  const [collapsed, setCollapsed] = useState(true);
  const [t] = useTranslation();

  return (
    <div className="my-6">
      <div className="font-header text-primary-500 border-b-3 border-b-solid border-b-primary-500 mb-6 grid grid-cols-12 gap-4 pb-4 text-2xl font-medium">
        <div className="col-span-10">
          {t('Pages:JudgeWeb.ScoresheetPage.flawsSection', 'Flaws')}
        </div>
        <div className="relative col-span-2 flex justify-end">
          <div
            onClick={() => setCollapsed(!collapsed)}
            className={classNames(
              collapsed ? 'icon-[ph--caret-down]' : 'icon-[ph--caret-up]',
              'text-content-500 dark:text-content-100 mr-4 h-6 w-6 cursor-pointer',
            )}
          />
        </div>
      </div>
      <>
        {!collapsed && (
          <section
            className="transition-all duration-300"
          >
            {scoresheet?.values?.flaws?.map((flaw) => {
              return (
                <div className="col-span-12" key={flaw?.id}>
                  <FlawBadge flaw={flaw} />
                </div>
              );
            })}
          </section>
        )}
      </>
    </div>
  );
};

export default FlawsSection;
